export default "__VITE_PUBLIC_ASSET__c672fb9d__"